import { Directive } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @deprecated This Angular directive is deprecated and should not be used.
 */
@Directive({
  selector: '[ctrRadioButton]',
  standalone: true,
})
export class RadioButtonDirective {
  hotelColor = '#000';
  unsubscribe$ = new Subject<void>();
}
